import writeXlsxFile, { Schema } from "write-excel-file"
import { ReportItem } from "./types"
import { getMessage } from "../../../msgs/msgs"
import { windowLock, windowRelease } from "../../../utils/loader"

export const formWbReportXlsx = async (
  reportName: string,
  reportData: ReportItem[],
) => {
  try {
    windowLock()
    writeXlsxFile<ReportItem>(reportData, {
      schema,
      fileName: `${reportName}.xlsx`,
    })
  } finally {
    windowRelease()
  }
}

const schema: Schema<ReportItem> = [
  {
    column: getMessage("realizationreport_id"),
    value: (item: ReportItem) => item.realizationreport_id,
  },
  {
    column: getMessage("date_from"),
    value: (item: ReportItem) => item.date_from,
  },
  {
    column: getMessage("date_to"),
    value: (item: ReportItem) => item.date_to,
  },
  {
    column: getMessage("create_dt"),
    value: (item: ReportItem) => item.create_dt,
  },
  {
    column: getMessage("currency_name"),
    value: (item: ReportItem) => item.currency_name,
  },
  {
    column: getMessage("suppliercontract_code"),
    value: (item: ReportItem) => item.suppliercontract_code,
  },
  {
    column: getMessage("rrd_id"),
    value: (item: ReportItem) => item.rrd_id,
  },
  {
    column: getMessage("gi_id"),
    value: (item: ReportItem) => item.gi_id,
  },
  {
    column: getMessage("dlv_prc"),
    value: (item: ReportItem) => item.dlv_prc,
  },
  {
    column: getMessage("fix_tariff_date_from"),
    value: (item: ReportItem) => item.fix_tariff_date_from,
  },
  {
    column: getMessage("fix_tariff_date_to"),
    value: (item: ReportItem) => item.fix_tariff_date_to,
  },
  {
    column: getMessage("subject_name"),
    value: (item: ReportItem) => item.subject_name,
  },
  {
    column: getMessage("nm_id"),
    value: (item: ReportItem) => item.nm_id,
  },
  {
    column: getMessage("brand_name"),
    value: (item: ReportItem) => item.brand_name,
  },
  {
    column: getMessage("sa_name"),
    value: (item: ReportItem) => item.sa_name,
  },
  {
    column: getMessage("ts_name"),
    value: (item: ReportItem) => item.ts_name,
  },
  {
    column: getMessage("barcode"),
    value: (item: ReportItem) => item.barcode,
  },
  {
    column: getMessage("doc_type_name"),
    value: (item: ReportItem) => item.doc_type_name,
  },
  {
    column: getMessage("quantity"),
    value: (item: ReportItem) => item.quantity,
  },
  {
    column: getMessage("retail_price"),
    value: (item: ReportItem) => item.retail_price,
  },
  {
    column: getMessage("_installed_price"),
    value: (item: ReportItem) => item._installed_price,
    backgroundColor: "#d4edda",
  },
  {
    column: getMessage("_storage_price"),
    value: (item: ReportItem) => item._storage_price,
    backgroundColor: "#d4edda",
  },
  {
    column: getMessage("_total_price"),
    value: (item: ReportItem) => item._storage_price || item._installed_price,
    backgroundColor: "#d4edda",
  },
  {
    column: getMessage("_storage"),
    value: (item: ReportItem) => item._storage,
    backgroundColor: "#d4edda",
  },
  {
    column: getMessage("_installed_price"),
    value: (item: ReportItem) => item._installed_date,
    backgroundColor: "#d4edda",
  },
  {
    column: getMessage("order_dt"),
    value: (item: ReportItem) => item.order_dt,
  },
  {
    column: getMessage("retail_amount"),
    value: (item: ReportItem) => item.retail_amount,
  },
  {
    column: getMessage("sale_percent"),
    value: (item: ReportItem) => item.sale_percent,
  },
  {
    column: getMessage("commission_percent"),
    value: (item: ReportItem) => item.commission_percent,
  },
  {
    column: getMessage("office_name"),
    value: (item: ReportItem) => item.office_name,
  },
  {
    column: getMessage("supplier_oper_name"),
    value: (item: ReportItem) => item.supplier_oper_name,
  },
  {
    column: getMessage("sale_dt"),
    value: (item: ReportItem) => item.sale_dt,
  },
  {
    column: getMessage("rr_dt"),
    value: (item: ReportItem) => item.rr_dt,
  },
  {
    column: getMessage("shk_id"),
    value: (item: ReportItem) => item.shk_id,
  },
  {
    column: getMessage("retail_price_withdisc_rub"),
    value: (item: ReportItem) => item.retail_price_withdisc_rub,
  },
  {
    column: getMessage("delivery_amount"),
    value: (item: ReportItem) => item.delivery_amount,
  },
  {
    column: getMessage("return_amount"),
    value: (item: ReportItem) => item.return_amount,
  },
  {
    column: getMessage("delivery_rub"),
    value: (item: ReportItem) => item.delivery_rub,
  },
  {
    column: getMessage("gi_box_type_name"),
    value: (item: ReportItem) => item.gi_box_type_name,
  },
  {
    column: getMessage("product_discount_for_report"),
    value: (item: ReportItem) => item.product_discount_for_report,
  },
  {
    column: getMessage("supplier_promo"),
    value: (item: ReportItem) => item.supplier_promo,
  },
  {
    column: getMessage("ppvz_spp_prc"),
    value: (item: ReportItem) => item.ppvz_spp_prc,
  },
  {
    column: getMessage("ppvz_kvw_prc_base"),
    value: (item: ReportItem) => item.ppvz_kvw_prc_base,
  },
  {
    column: getMessage("ppvz_kvw_prc"),
    value: (item: ReportItem) => item.ppvz_kvw_prc,
  },
  {
    column: getMessage("sup_rating_prc_up"),
    value: (item: ReportItem) => item.sup_rating_prc_up,
  },
  {
    column: getMessage("is_kgvp_v2"),
    value: (item: ReportItem) => item.is_kgvp_v2,
  },
  {
    column: getMessage("ppvz_sales_commission"),
    value: (item: ReportItem) => item.ppvz_sales_commission,
  },
  {
    column: getMessage("ppvz_for_pay"),
    value: (item: ReportItem) => item.ppvz_for_pay,
  },
  {
    column: getMessage("ppvz_reward"),
    value: (item: ReportItem) => item.ppvz_reward,
  },
  {
    column: getMessage("acquiring_fee"),
    value: (item: ReportItem) => item.acquiring_fee,
  },
  {
    column: getMessage("acquiring_percent"),
    value: (item: ReportItem) => item.acquiring_percent,
  },
  {
    column: getMessage("payment_processing"),
    value: (item: ReportItem) => item.payment_processing,
  },
  {
    column: getMessage("acquiring_bank"),
    value: (item: ReportItem) => item.acquiring_bank,
  },
  {
    column: getMessage("ppvz_vw"),
    value: (item: ReportItem) => item.ppvz_vw,
  },
  {
    column: getMessage("ppvz_vw_nds"),
    value: (item: ReportItem) => item.ppvz_vw_nds,
  },
  {
    column: getMessage("ppvz_office_name"),
    value: (item: ReportItem) => item.ppvz_office_name,
  },
  {
    column: getMessage("ppvz_office_id"),
    value: (item: ReportItem) => item.ppvz_office_id,
  },
  {
    column: getMessage("ppvz_supplier_id"),
    value: (item: ReportItem) => item.ppvz_supplier_id,
  },
  {
    column: getMessage("ppvz_supplier_name"),
    value: (item: ReportItem) => item.ppvz_supplier_name,
  },
  {
    column: getMessage("ppvz_inn"),
    value: (item: ReportItem) => item.ppvz_inn,
  },
  {
    column: getMessage("declaration_number"),
    value: (item: ReportItem) => item.declaration_number,
  },
  {
    column: getMessage("bonus_type_name"),
    value: (item: ReportItem) => item.bonus_type_name,
  },
  {
    column: getMessage("sticker_id"),
    value: (item: ReportItem) => item.sticker_id,
  },
  {
    column: getMessage("site_country"),
    value: (item: ReportItem) => item.site_country,
  },
  {
    column: getMessage("srv_dbs"),
    value: (item: ReportItem) => item.srv_dbs,
  },
  {
    column: getMessage("penalty"),
    value: (item: ReportItem) => item.penalty,
  },
  {
    column: getMessage("additional_payment"),
    value: (item: ReportItem) => item.additional_payment,
  },
  {
    column: getMessage("rebill_logistic_cost"),
    value: (item: ReportItem) => item.rebill_logistic_cost,
  },
  {
    column: getMessage("rebill_logistic_org"),
    value: (item: ReportItem) => item.rebill_logistic_org,
  },
  {
    column: getMessage("storage_fee"),
    value: (item: ReportItem) => item.storage_fee,
  },
  {
    column: getMessage("deduction"),
    value: (item: ReportItem) => item.deduction,
  },
  {
    column: getMessage("acceptance"),
    value: (item: ReportItem) => item.acceptance,
  },
  {
    column: getMessage("assembly_id"),
    value: (item: ReportItem) => item.assembly_id,
  },
  {
    column: getMessage("kiz"),
    value: (item: ReportItem) => item.kiz,
  },
  {
    column: getMessage("srid"),
    value: (item: ReportItem) => item.srid,
  },
  {
    column: getMessage("report_type"),
    value: (item: ReportItem) => item.report_type,
  },
  {
    column: getMessage("is_legal_entity"),
    value: (item: ReportItem) => item.is_legal_entity,
  },
  {
    column: getMessage("trbx_id"),
    value: (item: ReportItem) => item.trbx_id,
  },
  {
    column: getMessage("installment_cofinancing_amount"),
    value: (item: ReportItem) => item.installment_cofinancing_amount,
  },
  {
    column: getMessage("wibes_wb_discount_percent"),
    value: (item: ReportItem) => item.wibes_wb_discount_percent,
  },
  {
    column: getMessage("cashback_amount"),
    value: (item: ReportItem) => item.cashback_amount,
  },
  {
    column: getMessage("cashback_discount"),
    value: (item: ReportItem) => item.cashback_discount,
  },
  {
    column: getMessage("cashback_commission_change"),
    value: (item: ReportItem) => item.cashback_commission_change,
  },
  {
    column: getMessage("order_uid"),
    value: (item: ReportItem) => item.order_uid,
  },
]
